import React from 'react';


function PrivacyPolicy() {
  return (
    <>

      <div className="max-w-4xl mx-auto py-12 px-6">
        <h1 className="text-3xl font-bold text-[#102A43] mb-8 border-b border-gray-200 pb-4">Privacy Policy</h1>

        <div className="space-y-8 text-gray-800">
          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-3">1. Information Collection</h2>
            <p className="mb-2">
              The AI Accountability Standards Council (AASC) minimizes data collection. We collect information only when explicitly provided by visitors, such as through contact inquiries or newsletter subscriptions.
            </p>
            <p>
              Server logs may automatically record basic access data, including IP addresses, browser types, and access times, for security and maintenance purposes.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-3">2. Use of Information</h2>
            <p>
              Collected information is used solely for the purpose of communicating standards updates, responding to inquiries, and maintaining website security. The Council does not sell, rent, or trade user data to commercial vendors or third parties.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-3">3. Data Retention</h2>
            <p>
              Personal data is retained only as long as necessary to fulfill the purpose for which it was collected or as required by law. Routine server logs are rotated and deleted periodically.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-3">4. Security</h2>
            <p>
              We implement reasonable administrative, technical, and physical security measures to protect information from unauthorized access, alteration, or destruction.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-3">5. Third Parties</h2>
            <p>
              This website may utilize third-party services for hosting, analytics, or content delivery. These providers are bound by data processing agreements ensuring compliance with standard privacy protections.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-3">6. Cookies</h2>
            <p>
              This site uses essential cookies necessary for site functionality. We do not use advertising or tracking cookies for behavioral targeting.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-3">7. External Links</h2>
            <p>
              This website contains links to external sites, including the AASC Registry Platform. The Council is not responsible for the privacy practices or content of external sites.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-3">8. Children's Privacy</h2>
            <p>
              The AASC website is intended for professional audiences. We do not knowingly collect personal information from children under the age of 13.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-3">9. Policy Changes</h2>
            <p>
              The Council reserves the right to update this policy. Changes will be posted on this page with an updated effective date.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-3">10. Contact Information</h2>
            <p>
              For privacy-related inquiries, please contact the Secretariat at privacy@aiaccountabilitycouncil.com.
            </p>
          </section>
        </div>
      </div>
    </>
  );
}

export default PrivacyPolicy;